var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _vm.withKeyword
        ? _c(
            "div",
            { staticClass: "characteristic-select-inline--search" },
            [
              _c("SearchInput", {
                attrs: {
                  placeholder: _vm.keywordPlaceholder,
                  "characteristic-type": _vm.characteristicType,
                  catalog: _vm.searchCatalog
                },
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNothingAllowed
        ? _c(
            "div",
            { staticClass: "characteristic-select-inline--nothing-allowed" },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { checked: _vm.isNothingChecked },
                  on: { change: _vm.nothingChanged }
                },
                [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.nothingAllowed.text) + "\n\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.suppressItemsInfo
                ? _c(
                    "div",
                    { staticClass: "characteristic-select-inline--items-info" },
                    [
                      _vm.showMultipleHint
                        ? [
                            _vm._v("\n\t\t\t\tOder "),
                            _c(
                              "span",
                              { staticClass: "font-weight-extra-bold" },
                              [_vm._v("Mehrfachauswahl")]
                            ),
                            _vm._v(" möglich:\n\t\t\t")
                          ]
                        : [_vm._v("Oder wähle aus:")]
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm.showMultipleHint && _vm.filteredCharacteristicItems.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "characteristic-select-inline--items-info font-weight-extra-bold"
            },
            [_vm._v("\n\t\tMehrfachauswahl möglich:\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.filteredCharacteristicItems.length === 0
        ? _c("div", [
            _vm._v(
              "\n\t\tKein Treffer gefunden. Bitte gib ein anderes Wort ein, das dasselbe oder etwas Ähnliches bedeutet.\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.itemsGroupedByLetter, function(itemGroup) {
        return _c(
          "div",
          { key: itemGroup.id },
          [
            itemGroup.separation
              ? _c("Separation", {
                  staticClass: "characteristic-select-inline--items-separation",
                  attrs: { separation: itemGroup.separation }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(itemGroup.items, function(characteristics, letter) {
              return _c(
                "div",
                {
                  key: letter,
                  staticClass: "characteristic-select-inline--letter-section"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "characteristic-select-inline--letter-section-letter"
                    },
                    [_vm._v(_vm._s(letter))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "characteristic-select-inline--letter-section-items"
                    },
                    _vm._l(characteristics, function(characteristic) {
                      return _c(
                        "div",
                        {
                          key: characteristic.id,
                          class: [
                            "characteristic-select-inline--item",
                            { "has-icon": _vm.hasIcon(characteristic) }
                          ]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "characteristic-select-inline--item-label"
                            },
                            [
                              _vm.singleChoice
                                ? _c(
                                    "b-form-radio",
                                    {
                                      ref:
                                        "characteristic-select-" +
                                        characteristic.id,
                                      refInFor: true,
                                      class: {
                                        "has-childs": _vm.hasChilds(
                                          characteristic
                                        )
                                      },
                                      attrs: {
                                        checked: _vm.isSelected(characteristic)
                                          ? characteristic.id
                                          : undefined,
                                        name: "radio-" + _vm.key,
                                        value: characteristic.id,
                                        disabled: _vm.disabled
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectOrUnselect(
                                            characteristic,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("ValueLabel", {
                                        attrs: {
                                          characteristic: characteristic,
                                          "has-icon": _vm.hasIcon(
                                            characteristic
                                          ),
                                          "icon-path": _vm.iconPath,
                                          "description-config":
                                            _vm.descriptionConfig,
                                          "label-type": _vm.labelType,
                                          "highlight-words": _vm.highlightWords
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-form-checkbox",
                                    {
                                      ref:
                                        "characteristic-select-" +
                                        characteristic.id,
                                      refInFor: true,
                                      class: {
                                        "has-childs": _vm.hasChilds(
                                          characteristic
                                        )
                                      },
                                      attrs: {
                                        checked: _vm.isSelected(characteristic),
                                        disabled: _vm.disabled
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectOrUnselect(
                                            characteristic,
                                            $event
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("ValueLabel", {
                                        attrs: {
                                          characteristic: characteristic,
                                          "has-icon": _vm.hasIcon(
                                            characteristic
                                          ),
                                          "icon-path": _vm.iconPath,
                                          "description-config":
                                            _vm.descriptionConfig,
                                          "label-type": _vm.labelType,
                                          "highlight-words": _vm.highlightWords
                                        }
                                      })
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _vm.isSelected(characteristic) &&
                              _vm.hasChilds(characteristic)
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.openFan(characteristic)
                                        }
                                      }
                                    },
                                    [_c("Icon", { attrs: { icon: "pencil" } })],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.mustChooseSupplements(characteristic)
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.relevantItemCharacteristicTypes(
                                    characteristic
                                  ),
                                  function(itemCharacteristicType) {
                                    return _c("Supplements", {
                                      key: itemCharacteristicType.id,
                                      attrs: {
                                        "item-characteristic-type": itemCharacteristicType,
                                        "initial-selected": _vm.getInitialSupplements(
                                          characteristic,
                                          itemCharacteristicType
                                        ),
                                        "nothing-allowed":
                                          _vm.supplementsConfig &&
                                          _vm.supplementsConfig
                                            .nothingAllowed !== undefined
                                            ? _vm.supplementsConfig
                                                .nothingAllowed
                                            : true,
                                        "label-type": _vm.labelType
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.setSupplements(
                                            characteristic,
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSelected(characteristic) &&
                          !_vm.hasChilds(characteristic) &&
                          (_vm.withExperience || _vm.withSelfAssessment)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "characteristic-select-inline--item-additions"
                                },
                                [
                                  _vm.withExperience
                                    ? _c(
                                        "div",
                                        [
                                          _vm.experienceConfig &&
                                          _vm.experienceConfig.title
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-size-smaller mb-1"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.experienceConfig
                                                          .title
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("Select", {
                                            attrs: {
                                              value: _vm.getExperience(
                                                characteristic
                                              ),
                                              options: _vm.experienceOptions,
                                              smaller: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.setExperience(
                                                  characteristic,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.mustChooseSelfAssessment(characteristic)
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-size-smaller my-1"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.selfAssessmentTitle
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("Select", {
                                            attrs: {
                                              value: _vm.getSelfAssessment(
                                                characteristic
                                              ),
                                              options: _vm.selfAssessmentOptions
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.setSelfAssessment(
                                                  characteristic,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.mustChooseRequirement(characteristic)
                                    ? _c(
                                        "div",
                                        [
                                          _c("Dropdown", {
                                            attrs: {
                                              value: _vm.getRequirement(
                                                characteristic
                                              ),
                                              "custom-options":
                                                _vm.requirementOptions,
                                              placeholder:
                                                _vm.labels
                                                  .requirementPlaceholder,
                                              multiple: false
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.setRequirement(
                                                  characteristic,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showNothingLabel(characteristic)
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "characteristic-selected-items level-0"
                                },
                                [
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.openFan(characteristic)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.nothingLabelNextLevel)
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSelected(characteristic) &&
                          _vm.hasSelectedChildsToLastLevel(characteristic)
                            ? _c("SelectedChilds", {
                                attrs: {
                                  characteristic: characteristic,
                                  selected: _vm.selected,
                                  "no-children-appendix": _vm.selectedChildsConfig
                                    ? _vm.selectedChildsConfig
                                        .noChildrenAppendix
                                    : undefined
                                },
                                on: {
                                  editItem: function($event) {
                                    return _vm.openFan($event.item, true)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          characteristic.hint && _vm.isSelected(characteristic)
                            ? _c("div", {
                                staticClass:
                                  "characteristic-select-inline--item-hint",
                                domProps: {
                                  innerHTML: _vm._s(characteristic.hint)
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            })
          ],
          2
        )
      }),
      _vm._v(" "),
      !_vm.shouldShowAll && _vm.remainingCount > 0
        ? _c(
            "div",
            { staticClass: "characteristic-select-inline--show-more" },
            [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.showAll = true
                    }
                  }
                },
                [
                  _c("Icon", { attrs: { icon: "caret-down" } }),
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.remainingCount) + " weitere\n\t\t"
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deselectCharacteristic
        ? _c("DeselectPopUp", {
            attrs: { characteristic: _vm.deselectCharacteristic },
            on: {
              edit: function($event) {
                return _vm.editAlreadySelectedCharacteristic(
                  _vm.deselectCharacteristic
                )
              },
              remove: function($event) {
                return _vm.onDeSelectCharacteristic(_vm.deselectCharacteristic)
              },
              hidden: _vm.dismissCharacteristicRemoval
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }